import { featureItem } from "@/mocks/home-data";
import SectionHeading from "./SectionHeading";

export default function FeatureModule() {
  return (
    <section id="toutiao" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          kicker="劲爆盘点 · 本期头条"
          title={<>先把这期大瓜吃明白</>}
          right={
            <span className="hidden items-center gap-1.5 font-label text-xs font-medium text-foreground-500 sm:inline-flex">
              <i className="ri-vip-diamond-line text-primary-500" /> 编辑部速读 · 读完约 3 分钟
            </span>
          }
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {/* 视觉：封面大图 */}
          <figure className="group relative overflow-hidden rounded-lg border border-background-200">
            <img
              src={featureItem.cover}
              alt={featureItem.titleA}
              title={featureItem.titleA}
              className="h-[260px] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-[360px] lg:h-full lg:min-h-[420px]"
            />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1.5 font-label text-xs font-semibold text-background-50">
              <i className="ri-fire-fill" /> 爆雷指数 98
            </span>
            <figcaption className="absolute bottom-0 inset-x-0 flex items-end justify-between gap-3 bg-gradient-to-t from-foreground-950/85 to-transparent p-4 pt-12 text-background-50 md:p-6">
              <div className="flex items-center gap-4 text-xs">
                <span className="inline-flex items-center gap-1.5"><i className="ri-eye-line" /> {featureItem.statReads} 阅读</span>
                <span className="inline-flex items-center gap-1.5"><i className="ri-chat-3-line" /> {featureItem.statComments} 评论</span>
              </div>
              <span className="rounded-full border border-background-50/40 px-3 py-1 font-label text-[11px]">{featureItem.issue}</span>
            </figcaption>
          </figure>

          {/* 文案 */}
          <div className="flex flex-col justify-center rounded-lg border border-background-200 bg-background-100/60 p-6 md:p-8">
            <span className="inline-flex w-max items-center gap-2 font-label text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
              <i className="ri-record-circle-fill text-sm" /> {featureItem.kicker}
            </span>
            <h3 className="display-serif mt-4 text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
              {featureItem.titleA}
              <span className="text-primary-600">{featureItem.titleB}</span>
            </h3>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
              {featureItem.lead}
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {featureItem.chips.map((c) => (
                <span key={c} className="rounded-full bg-secondary-100 px-3 py-1.5 font-label text-xs font-medium text-secondary-900">
                  {c}
                </span>
              ))}
            </div>

            <div className="mt-6 border-t border-background-200 pt-5">
              <div className="flex flex-wrap items-center gap-3">
                <a
                  href="#mailuo"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  看完整事件脉络 <i className="ri-arrow-right-line" />
                </a>
                <a
                  href="#changchang"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  <i className="ri-heart-3-line" /> 参与站队
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}